import { Button, IconArrowUpRight, IconUsers, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { Rule, RuleActions, RuleIcon, RuleStack } from 'ui'
import { messages } from './messages'
import { styles } from './styles'
import { useAdmin } from '@vtex/raccoon-next'

export function AudienceConditions() {
  const { account } = useAdmin()

  const navigateToAudiences = () =>
    window.open(`https://${account}.myvtex.com/admin/rnb#/campaigns`, '_blank')

  return (
    <Rule>
      <RuleIcon className={styles.icon}>
        <IconUsers />
      </RuleIcon>

      <div className={styles.content}>
        <Text variant="action1">
          <FormattedMessage {...messages.title} />
        </Text>
        <Text variant="detail" tone="secondary">
          <FormattedMessage {...messages.subtitle} />
        </Text>
      </div>

      <RuleActions className={styles.actions}>
        <Button
          variant="neutralTertiary"
          onClick={navigateToAudiences}
          icon={<IconArrowUpRight />}
          iconPosition="end"
        >
          <FormattedMessage {...messages.goToAudiences} />
        </Button>
      </RuleActions>
    </Rule>
  )
}
